@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (reisaftrekOpenbaarVervoer.length > 0) {
      <div formArrayName="reisaftrekOpenbaarVervoer">
        @for (item of reisaftrekOpenbaarVervoer.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row col-auto" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Arbeidsplaats' : ''"
                                            class="custom-input-250 col-auto"
                                            formControlName="omschrijving"
                                            id="omschrijving"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Afstand enkele reis' : ''"
                                              align="right"
                                              class="custom-input-150 col-auto"
                                              formControlName="afstandEnkeleReis"
                                              id="afstandEnkeleReis"
                                              prefix="km"
            >
            </snelstart-ui-number-form-control>
            <div class="col-auto row" formGroupName="periodeVanReizen" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-date-form-control [label]="i === 0 ? 'Begindatum' : ''"
                                              class="col-auto custom-input-150"
                                              formControlName="begindatum"
                                              id="begindatum"
              >
              </snelstart-ui-date-form-control>
              <snelstart-ui-date-form-control [label]="i === 0 ? 'Einddatum' : ''"
                                              class="col-auto custom-input-150"
                                              formControlName="einddatum"
                                              id="einddatum"
              >
              </snelstart-ui-date-form-control>
            </div>
            <snelstart-ui-select-form-control [label]="i === 0 ? 'Reisdagen per week' : ''"
                                              [options]="optionsAantalDagen"
                                              class="custom-input-150"
                                              formControlName="aantalDagenPerWeek"
            >
            </snelstart-ui-select-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Vergoeding werkg.' : ''"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="vergoedingWerkgever"
                                              id="vergoedingWerkgever"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRij(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                 class="delete"
                                 icon="trash"
                                 iconType="light"
                                 id="buttonDelete"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        }
      </div>
    }
  </form>
}

<snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                     type="link">Reiskosten toevoegen
</snelstart-ui-button>

